import isEmpty from 'lodash-es/isEmpty';
import { useTranslation } from 'react-i18next';

import { Chip } from '@/components/atoms/Chip/Chip';
import { GooglesheetAction } from '@/shared/types/action';

const GoogleSheet = ({ action }: { action: GooglesheetAction }) => {
  const { t } = useTranslation();
  const { inputs = [], sheet_id } = action;
  const totalInputs = inputs.length;
  const hiddenInputs = totalInputs - 2;

  return (
    <>
      <div className="text-sm leading-5 font-normal text-foreground-muted">
        {t('actions.googlesheet.sheet', { 0: sheet_id })}
      </div>
      <div className="mt-1.5 flex flex-wrap items-center gap-y-1">
        {inputs.slice(0, 2).map((label: string) => (
          <Chip key={label} size="xs" className="mr-1">
            {label}
          </Chip>
        ))}
        {totalInputs > 2 && (
          <span className="ml-2 text-sm leading-5 font-normal">{`+${hiddenInputs}`}</span>
        )}
        {isEmpty(inputs) && <p>{t('dialog.no_input')}</p>}
      </div>
    </>
  );
};

export default GoogleSheet;
